import { apiGetProfile } from '../api/dashboard/dashboard';
import {
    apiUpdateName,
    apiUpdatePhone,
    apiUpdatePassword,
    apiGetQrCode,
    apiAddTwoFactor,
    apiDeleteQrCode,
    apiChangeLanguage,
} from '../api/profile/profile';

export const profileService = {
    async getProfile() {
        return await apiGetProfile();
    },

    async updateName(firstName: string, lastName: string) {
        return await apiUpdateName({ firstName, lastName });
    },

    async updatePhone(phone: string) {
        return await apiUpdatePhone(phone);
    },

    async updatePassword(password: string, confirmPassword: string) {
        return await apiUpdatePassword({ password, confirmPassword });
    },

    async getQrCode() {
        return await apiGetQrCode();
    },

    async addTwoFactor(totp_token: string) {
        return await apiAddTwoFactor(totp_token);
    },

    async deleteQrCode() {
        return await apiDeleteQrCode();
    },

    async changeLanguage(lang: string) {
        return await apiChangeLanguage(lang);
    },
};
